<template>
  <div class="product-page">
    <nav-bar />

    <!-- Hero 区 -->
    <section class="product-hero">
      <div class="hero-bg" />
      <div class="hero-inner g-container">
        <div class="hero-text">
          <span class="eyebrow">保函产品 · 全场景覆盖</span>
          <h1>为你的投标<br/>提供专业电子保函</h1>
          <p>纯信用 · 免保证金 · 线上办理 · 最快 3min出函</p>
          <div class="hero-cta">
            <button class="g-btn g-btn-primary g-btn-lg" @click="$router.push('/project')">立即申请</button>
            <button class="g-btn g-btn-default g-btn-lg" @click="$router.push('/search')">保函验真</button>
          </div>
          <ul class="hero-pills">
            <li><span>1</span> 选择保函类型</li>
            <li><span>2</span> 提交企业信息</li>
            <li><span>3</span> 在线支付</li>
            <li><span>4</span> 获取电子保函</li>
          </ul>
        </div>
        <div class="hero-visual">
          <div class="visual-card">
            <div class="visual-head">
              <div class="dot dot-r"></div>
              <div class="dot dot-y"></div>
              <div class="dot dot-g"></div>
            </div>
            <div class="visual-body">
              <div class="v-title">电子投标保函</div>
              <ul>
                <li><span>担保机构</span><strong>余干县干越融资担保有限公司</strong></li>
                <li><span>担保类型</span><strong>投标保证</strong></li>
                <li><span>费率</span><strong class="num">0.3% 起</strong></li>
                <li><span>出函时效</span><strong>最快 3min</strong></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 主体：分类 + 列表 -->
    <section class="product-body g-container">
      <!-- 左侧分类 -->
      <aside class="cat-panel g-card">
        <div class="cat-head">产品分类</div>
        <ul class="cat-list">
          <li
            v-for="t in tabList"
            :key="t.code"
            :class="['cat-item', code === t.code && 'is-active']"
            @click="changeTab(t.code)"
          >
            <i class="cat-dot"></i>
            <span class="cat-name">{{ t.name }}</span>
            <i class="cat-arrow">›</i>
          </li>
        </ul>

        <div class="cat-contact">
          <p class="t">合作机构</p>
          <strong>余干县干越融资担保有限公司</strong>
          <p class="d">蒋经理：19179363419</p>
        </div>
      </aside>

      <!-- 右侧列表 -->
      <div class="list-area">
        <div class="list-bar">
          <h2>{{ activeTabName }}</h2>
          <div class="list-meta">共 {{ total }} 款产品</div>
        </div>

        <div v-if="list.length" class="prod-grid">
          <article
            v-for="item in list"
            :key="item.id"
            class="prod-card g-card"
            @click="checkDetail(item.id)"
          >
            <header class="prod-head">
              <div class="prod-name">
                <strong>{{ item.name }}</strong>
                <span>电子保函</span>
              </div>
            </header>
            <p class="prod-desc">{{ item.introduce }}</p>
            <ul class="prod-features">
              <li><span>额度</span><strong>1-300 万</strong></li>
              <li><span>费率</span><strong>面议</strong></li>
              <li><span>出函</span><strong>最快 3min</strong></li>
            </ul>
            <footer class="prod-foot">
              <span class="prod-cta">查看详情 →</span>
            </footer>
          </article>
        </div>

        <div v-else class="g-empty">
          <img src="@/assets/noData.png" />
          <p>该分类暂无产品</p>
        </div>

        <el-pagination
          v-if="list.length"
          background
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="pageNum"
          @current-change="fetch"
          class="pager"
        />
      </div>
    </section>

    <site-footer />
    <auth-modal ref="authModal" />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import SiteFooter from '@/components/SiteFooter'
import AuthModal from '@/components/AuthModal'
import { getProList, getProListByToken, getProduct, getProductByToken } from '@/lib/api/product'

export default {
  name: 'product',
  components: { NavBar, SiteFooter, AuthModal },
  data () {
    return {
      code: '',
      pageNum: 1,
      total: 0,
      list: [],
      tabList: []
    }
  },
  computed: {
    activeTabName () {
      const t = this.tabList.find((c) => c.code === this.code)
      return t ? t.name : '全部产品'
    }
  },
  watch: {
    $route () {
      this.fetch(1)
    }
  },
  created () {
    if (localStorage.getItem('token')) {
      getProListByToken(0).then((res) => {
        if (res.code === 200) {
          this.tabList = res.data
          this.code = res.data[0].code
          this.fetch(1)
        }
      })
    } else {
      getProList(0).then((res) => {
        if (res.code === 200) {
          this.tabList = res.data
          this.code = res.data[0].code
          this.fetch(1)
        }
      })
    }
  },
  methods: {
    fetch (page = 1) {
      this.pageNum = page
      const fn = localStorage.getItem('token') ? getProductByToken : getProduct
      fn({ pageNum: page, pageSize: 9, code: this.code }).then((res) => {
        if (res.code === 200) {
          this.list = res.rows || []
          this.total = res.total || 0
        }
      })
    },
    changeTab (code) {
      this.code = code
      this.fetch(1)
    },
    checkDetail (id) {
      this.$router.push({ path: '/product_detail', query: { id, code: this.code } })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.product-page {
  min-height: 100vh;
  background: @bg-page;
}

.product-hero {
  position: relative;
  background: linear-gradient(135deg, #EFF6FF 0%, #F5F7FA 60%);
  overflow: hidden;
  margin-bottom: 32px;

  .hero-bg {
    position: absolute;
    inset: 0;
    background-image: radial-gradient(circle at 80% 20%, rgba(37, 99, 235, .12), transparent 50%);
    pointer-events: none;
  }
}

.hero-inner {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 32px;
  align-items: center;
  padding: 80px 24px 96px;
}

.hero-text {
  .eyebrow {
    display: inline-block;
    padding: 6px 14px;
    background: #fff;
    border: 1px solid @primary-soft;
    border-radius: @radius-full;
    color: @primary;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  h1 {
    margin: 0 0 16px;
    font-size: 48px;
    font-weight: 800;
    line-height: 1.15;
    letter-spacing: -1px;
    color: @text-strong;
  }

  p {
    margin: 0 0 32px;
    font-size: 16px;
    color: @text-secondary;
  }

  .hero-cta {
    display: flex;
    gap: 12px;
    margin-bottom: 40px;
  }
}

.hero-pills {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  li {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    background: #fff;
    border-radius: @radius-full;
    font-size: 13px;
    color: @text-secondary;
    box-shadow: @shadow-sm;

    span {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background: @primary-soft;
      color: @primary;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 700;
    }
  }
}

.hero-visual {
  display: flex;
  justify-content: center;

  .visual-card {
    width: 460px;
    background: #fff;
    border-radius: @radius-xl;
    box-shadow: @shadow-xl;
    overflow: hidden;
  }

  .visual-head {
    display: flex;
    gap: 6px;
    padding: 14px 20px;
    background: @bg-soft;
    border-bottom: 1px solid @border-light;

    .dot {
      width: 10px; height: 10px;
      border-radius: 50%;
      background: #CBD5E1;
    }
    .dot-r { background: #FF6B6B; }
    .dot-y { background: #FFC75A; }
    .dot-g { background: #4ECB71; }
  }

  .visual-body {
    padding: 24px 28px 28px;

    .v-title {
      font-size: 18px;
      font-weight: 700;
      color: @text-strong;
      margin-bottom: 18px;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px dashed @border-light;
        font-size: 13px;

        &:last-child { border-bottom: none; }

        span { color: @text-muted; }
        strong { color: @text-strong; }
        .num { color: @danger; font-weight: 700; }
      }
    }
  }
}

.product-body {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 24px;
  padding: 0 24px 48px;
  align-items: flex-start;
}

.cat-panel {
  position: sticky;
  top: 92px;
  padding: 0;
  background: #fff;
  overflow: hidden;
}

.cat-head {
  padding: 18px 20px 12px;
  font-size: 16px;
  font-weight: 700;
  color: @text-strong;
  border-bottom: 1px solid @border-light;
}

.cat-list {
  list-style: none;
  margin: 0;
  padding: 8px;

  .cat-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    border-radius: @radius-md;
    cursor: pointer;
    transition: all @duration-fast @ease-out;
    color: @text-secondary;
    font-size: 14px;

    .cat-dot {
      width: 6px; height: 6px;
      border-radius: 50%;
      background: @border-strong;
    }

    .cat-arrow {
      margin-left: auto;
      font-size: 18px;
      color: @text-disabled;
      opacity: 0;
      transition: opacity @duration-fast @ease-out;
    }

    .cat-name { flex: 1; }

    &:hover {
      background: @bg-soft;
      color: @primary;
      .cat-dot { background: @primary; }
    }

    &.is-active {
      background: @primary-soft;
      color: @primary;
      font-weight: 600;
      .cat-dot { background: @primary; }
      .cat-arrow { opacity: 1; color: @primary; }
    }
  }
}

.cat-contact {
  margin: 8px;
  padding: 18px;
  background: linear-gradient(135deg, @primary-soft, #DBEAFE);
  border-radius: @radius-md;

  .t {
    margin: 0 0 6px;
    font-size: 12px;
    color: @text-secondary;
  }

  strong {
    display: block;
    color: @primary;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 8px;
  }

  .d {
    margin: 0;
    font-size: 12px;
    color: @text-muted;
  }
}

.list-area {
  min-height: 600px;
}

.list-bar {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 6px 0 20px;

  h2 {
    margin: 0;
    font-size: 22px;
    color: @text-strong;
    font-weight: 700;
  }

  .list-meta {
    color: @text-muted;
    font-size: 13px;
  }
}

.prod-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.prod-card {
  background: #fff;
  padding: 24px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all @duration-base @ease-out;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-4px);
    box-shadow: @shadow-lg;
    border-color: @primary-soft;

    .prod-cta { color: @primary-hover; transform: translateX(4px); }
  }
}

.prod-head {
  margin-bottom: 14px;

  .prod-name {
    display: flex;
    flex-direction: column;
    gap: 4px;

    strong {
      font-size: 16px;
      color: @text-strong;
    }
    span {
      font-size: 12px;
      color: @text-muted;
    }
  }
}

.prod-desc {
  color: @text-secondary;
  font-size: 13px;
  line-height: 1.7;
  margin: 0 0 16px;
  .multi-ellipsis(2);
}

.prod-features {
  list-style: none;
  margin: 0 0 16px;
  padding: 14px;
  background: @bg-soft;
  border-radius: @radius-md;

  li {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    font-size: 13px;

    span { color: @text-muted; }
    strong { color: @text-strong; }
  }
}

.prod-foot {
  margin-top: auto;
  display: flex;
  justify-content: flex-end;

  .prod-cta {
    color: @primary;
    font-weight: 600;
    font-size: 13px;
    transition: transform @duration-fast @ease-out;
  }
}

.pager {
  margin-top: 32px;
  text-align: center;
}

@media (max-width: 1180px) {
  .product-body { grid-template-columns: 200px 1fr; }
  .prod-grid { grid-template-columns: repeat(2, 1fr); }
  .hero-inner { grid-template-columns: 1fr; }
  .hero-visual { display: none; }
}
</style>
